import React from 'react';
import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';
import styles from './PublicLayout.module.css';

const PublicLayout = ({ children, className = '' }) => {
  return (
    <div className={`${styles.publicLayout} ${className}`}>
      <PublicNav />
      <main className={styles.publicMain}>
        {children}
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
